import type {
  CampaignGiftGetResponseBody,
  CampaignGiftGuestGetResponseBody,
} from '@/types/redemption'
import { useRuntimeConfig } from '#imports'
import { createApiUtils } from './utils'

const baseUrl = '/redemption/api/campaign/gift'

type GiftResponses = {
  getGift: CampaignGiftGetResponseBody
  getDependentGifts: CampaignGiftGetResponseBody[]
  getGiftById: CampaignGiftGetResponseBody
  findGift: CampaignGiftGuestGetResponseBody
  getAdminGift: CampaignGiftGetResponseBody
}

export const useGiftRepository = () => {
  const config = useRuntimeConfig()
  const { execute, getError } = createApiUtils<GiftResponses>()

  const getGiftHandle = (
    data: CampaignGiftGetResponseBody[] | null,
    isEyebot: boolean,
  ) => {
    if (
      !data ||
      data.length === 0 ||
      data.filter(
        ({ isActivated, isUsed }) => isActivated && (isEyebot ? !isUsed : true),
      ).length === 0
    ) {
      return null
    }
    return data.filter(
      ({ isActivated, isUsed }) => isActivated && (isEyebot ? !isUsed : true),
    )[0]
  }

  const getGift = (opts: any) =>
    ({
      url: baseUrl,
      options: {
        method: 'GET',
        ...opts,
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const getDependentGifts = (email: string) =>
    ({
      url: baseUrl,
      options: {
        method: 'GET',
        query: {
          email,
          includingDependent: true,
          isActivated: true,
        },
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const getGiftById = (id: string) =>
    ({
      url: `${baseUrl}/${id}`,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const findGift = (email: string) =>
    ({
      url: `${baseUrl}/guest`,
      options: {
        method: 'GET',
        query: {
          email,
        },
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const getAdminGift = (policyId: string, storeId: string) =>
    ({
      url: `/redemption/api/campaign/policy/${policyId}/admin/gift`,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': storeId,
        },
      },
    }) as const

  return {
    getGift,
    getGiftById,
    getDependentGifts,
    findGift,
    getAdminGift,
    getGiftHandle,
    execute,
    getError,
  }
}
